import {useNavigate} from "react-router-dom";

export default function UpdateButtonMenu(props) {
    const navigate = useNavigate();

    return (
        <button
            type="button"
            className="btn btn-link p-0"
            onClick={() => {
                if (props.onClick) {
                    props.onClick(props.row);
                    return;
                }
                navigate("/manage-job/update-job/" + props.row.cos_job_id);
            }}
        >
            Update
        </button>
    );
}
